import React from 'react';
import styled from 'styled-components';

/**
 * Button group container for aligning multiple buttons
 */
const StyledButtonGroup = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: ${({ flexWrap = true }) => (flexWrap ? 'wrap' : 'nowrap')};
    gap: 8px;
    margin-top: ${({ marginTop = '1rem' }) => marginTop};
`;

/**
 * ButtonGroup wrapper component for grouping multiple buttons
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Button elements to render inside the group
 * @returns {JSX.Element}
 */
const ButtonGroup = ({ children, ...restProps }) => {
    return <StyledButtonGroup {...restProps}>{children}</StyledButtonGroup>;
};

export default ButtonGroup;
